// Quote
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  border: 2vw solid lightgrey;
    blockquote{
    padding: 3vw 13vw;
    margin-bottom: 0 ;
    }
`;
function Quote({ className = "", ...props }) {
  const classNames = [ "common-quote uk-flex uk-justify-content uk-background-default-trans uk-text-center uk-box-shadow-medium", className ].join(" ");
  return (
    <Wrapper className={ classNames } data-uk-scrollspy="cls: uk-animation-slide-bottom-medium; delay: 0; repeat: true">
      <blockquote className="uk-margin-auto uk-text-center">{ props.quote }</blockquote>
    </Wrapper>
  );
}

Quote.propTypes = {
  quote: PropTypes.string,
  className: PropTypes.string
};

export default Quote;


// WEBPACK FOOTER //
// ./src/features/common/Quote.js